import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const deposit = createAsyncThunk(
  "deposit",
  async (payload, thunkAPI) => {
    try {
    
      const response = await api.post("deposit", payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const depositSlice = createSlice({
  name: "deposit",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deposit.pending, (state) => {
        state.loading = true;
      })
      .addCase(deposit.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deposit.rejected, (state, action) => {
        console.log(35, action.error)
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default depositSlice.reducer;
